import { Component } from '@angular/core';
import { Column } from '@app/shared/modules/smash-data-table/smash-data-table/smash-data-table.component';
import { DialogRef } from '@ngneat/dialog';

@Component({
  selector: 'app-modal-event-list',
  templateUrl: './modal-event-list.component.html',
  styleUrls: ['./modal-event-list.component.scss']
})
export class ModalEventListComponent {

  selectedIdentity: any;
  events: any[];

  filteredEvents: any[];

  columnsEnabledEvents: Column[] = [
    { id: 'accessDate', colName: 'MODAL_EVENT_LIST_LABEL_DATE', type: 'date', pipe: 'date' },
    {
      id: 'type', colName: 'MODAL_EVENT_LIST_LABEL_STATUS', type: 'string',
      translations: {
        View: 'MODAL_EVENT_LIST_LABEL_HAS_OPENED_TRANSFER',
        Download: 'MODAL_EVENT_LIST_LABEL_HAS_DOWNLOADED_TRANSFER',
      }
    },
  ];

  constructor(public ref: DialogRef) {
    this.selectedIdentity = this.ref.data.selectedIdentity;
    this.events = this.ref.data.events;
    if (this?.events?.length) {
      if (this.selectedIdentity.email) {
        this.filteredEvents = this.events.filter(event => event.email === this.selectedIdentity.email);
      }
      if (this.selectedIdentity.userId) {
        this.filteredEvents = this.events.filter(event => event.userId === this.selectedIdentity.userId && !event.email);
      }
    }
  }

  closeModal() {
    this.ref.close();
  }
}
